import React from "react";

const SafetyRules = ({ rules, onChange }) => {
    const set = (field, value) => onChange({ ...rules, [field]: value });
    
    return (
        <>
            <label className="crm-safety-row">
                <input
                    type="checkbox"
                    checked={!!rules.stopOnReply}
                    onChange={(e) => set("stopOnReply", e.target.checked)}
                />
                Stop sending if lead replies
            </label>

            <label className="crm-safety-row">
                <input
                    type="checkbox"
                    checked={!!rules.excludeLost}
                    onChange={(e) => set("excludeLost", e.target.checked)}
                />
                Exclude leads with &quot;Lost&quot; status
            </label>

            <label className="crm-safety-row">
                <input
                    type="checkbox"
                    checked={!!rules.skipContactedDays}
                    onChange={(e) => set("skipContactedDays", e.target.checked ? 7 : null)}
                />
                Skip recently emailed leads
            </label>

            {rules.skipContactedDays && (
                <div className="crm-safety-inline">
                    <span>Skip leads emailed in the last</span>
                    <input
                        type="number"
                        min={1}
                        max={365}
                        value={rules.skipContactedDays}
                        onChange={(e) => set("skipContactedDays", Math.max(1, parseInt(e.target.value) || 1))}
                    />
                    <span>days</span>
                </div>
            )}
        </>
    );
};

export default SafetyRules;
